import { z } from "zod";

export const DEFAULT_WORKSPACE_PREFERENCES_VALUES = {
	hideFirmwareUpdateUserPrompt: false,
	restrictInvitesToAdmins: false,
};

export const workspacePreferencesFieldsSchema = z.object({
	hideFirmwareUpdateUserPrompt: z
		.boolean()
		.default(DEFAULT_WORKSPACE_PREFERENCES_VALUES.hideFirmwareUpdateUserPrompt),
	restrictInvitesToAdmins: z
		.boolean()
		.default(DEFAULT_WORKSPACE_PREFERENCES_VALUES.restrictInvitesToAdmins),
});

export const workspacePreferencesSchema = workspacePreferencesFieldsSchema.extend({
	workspaceId: z.string(),
});

export const workspacePreferencesRequestSchema = z.object({
	workspaceId: z.string(),
	hideFirmwareUpdateUserPrompt: z.boolean(),
	restrictInvitesToAdmins: z.boolean(),
});

export type WorkspacePreferencesFieldsSchema = z.infer<typeof workspacePreferencesFieldsSchema>;
export type WorkspacePreferencesSchema = z.infer<typeof workspacePreferencesSchema>;
export type WorkspacePreferencesRequestSchema = z.infer<typeof workspacePreferencesRequestSchema>;
